var React = require('react');

function IndicatorPointer (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"IndicatorPointer"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M67.5,33.58C67.5,52.12,40,84,33.75,84S0,52.12,0,33.58a33.75,33.75,0,0,1,67.5,0Z"})))]);
}

IndicatorPointer.defaultProps = {"viewBox":"0 0 67.5 83.95"};

module.exports = IndicatorPointer;

IndicatorPointer.default = IndicatorPointer;
